export interface IEmotionCharacterCount {
	result_lastmodifieddate: string;
	result_value: string;
	result_count: number;
}

export const resourceNameEmotionCharacterCounts = `rpc/keyvaluelog_emotioncharacter_counts`;
